import produce from "immer"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

const initOkrKeyResultCommentState: types.OkrKeyResultCommentState = {
    commentList: {},
}

const okrKeyResultCommentReducer = produce((
    draft: types.OkrKeyResultCommentState = initOkrKeyResultCommentState,
    action: ActionTypes = null,
): types.OkrKeyResultCommentState => {
    switch (action.type) {
        case types.OKR_KEY_RESULT_COMMENT_LIST:
            draft.commentList = {
                ...draft.commentList,
                [action.keyResultId]: action.comments,
            }
            return draft

        default:
            return draft
    }
})
export default okrKeyResultCommentReducer
